import i18n from "i18next";
import { Fragment, useState } from "react";
import { inject, observer } from "mobx-react";

import { TalkbackIcon } from "../components/icons/TalkbackIcon.component";
import { DynamicHeaderItem } from "./DynamicHeaderItem.component";
import styles from "./HeaderTalkback.module.scss";
import type { Store } from "@inferno/renderer-shared-core";
import { HeaderTalkbackModal } from "./HeaderTalkbackModal.component";

export interface HeaderTalkbackProps {
  store?: Store;
}

export const HeaderTalkback = inject("store")(
  observer(({ store }: HeaderTalkbackProps) => {
    if (!store) {
      return null;
    }

    const [modalOpen, setModalOpen] = useState(false);

    return (
      <>
        <DynamicHeaderItem
          store={store}
          className={styles["component-talkback"]}
          iconOnlyClassName={styles["icon-only"]}
          buttonClassName={styles["toggle-btn"]}
          ariaLabel="Send Talkback"
          onClick={() => setModalOpen(true)}
          breakpoints={{
            showText: 1470,
            iconOnly: 1470,
          }}
          content={
            <Fragment>
              <TalkbackIcon />
              {i18n.t("send_talkback", { defaultValue: "Send Talkback" })}
            </Fragment>
          }
          iconOnlyContent={<TalkbackIcon />}
        />
        {modalOpen && <HeaderTalkbackModal open={modalOpen} onClose={() => setModalOpen(false)} />}
      </>
    );
  }),
);
